<template>
    <main id="Central__Calendar_Vue" class="page-layout-vue">
        <LevelTwo :router="router" />
        <main id="App__Calendar" ref="calendarRef" class="tes-calendar">
            <router-view />
        </main>
    </main>
</template>

<script lang="ts" src="./CentralCalendar.ts"></script>
<style src="./CentralCalendar.scss"></style>
